import { CandidateContactInformationSchema } from '@axiom/validation';
import type { z } from 'zod';

export const PreferencesContactInformationFormSchema =
  CandidateContactInformationSchema.pick({
    preferredContactMethod: true,
  });

export type PreferencesContactInformationForm = z.infer<
  typeof PreferencesContactInformationFormSchema
>;
